/* loaded by smart-asset */
export default require("./infinity~32a569ce3c4623f336c656e2f1c9c7b00f775c41.svg")